import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './footer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Footer = props => ___EmotionJSX("div", {
  css: styles.footer
}, ___EmotionJSX("div", {
  css: styles.body
}, ___EmotionJSX(Button, {
  size: "small",
  appearance: "ghost",
  onClick: props.onClick
}, "Done")));
Footer.propTypes = {
  onClick: PropTypes.func
};
Footer.defaultProps = {
  onClick: () => {}
};
export default Footer;